import { Component, OnInit, ComponentRef } from "@angular/core";
import {
  IModalDialog,
  IModalDialogOptions,
  IModalDialogButton,
  IModalDialogSettings,
} from "ngx-modal-dialog";
import { ApiService } from "../../../services/api.service";
import { UtilsService } from "../../../services/utils.service";

@Component({
  selector: "stop-onboarding-modal",
  templateUrl: "./stop-onboarding-modal.component.html",
  styleUrls: ["./stop-onboarding-modal.component.scss"],
})
export class StopOnboardingModalComponent implements OnInit, IModalDialog {
  public currentOnBoarding: any;
  actionButtons: IModalDialogButton[];
  actionSettings: IModalDialogSettings[];

  constructor(private api: ApiService, private utils: UtilsService) {
    this.actionButtons = [
      {
        text: "",
        buttonClass: "alg-btn-close",
        onAction: () => {
          this.utils.abilityOverflow();
          return true;
        },
      }, // no special processing here
      {
        text: "Chiudi",
        buttonClass: "button-full-close",
        onAction: () => {
          this.utils.abilityOverflow();
          return true;
        },
      },
    ];
  }

  ngOnInit() {
    this.api.currentOnboarding.subscribe((currentOnBoarding) => {
      this.currentOnBoarding = currentOnBoarding;
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const closeButton = document.getElementsByClassName("button-full-close");
      const exitButton = document.getElementsByClassName("alg-btn-close");
      // if(!exitButton[0]) return
      closeButton[0].setAttribute("id", "saveAndSuspend-close");
      closeButton[0].setAttribute("type", "button");
      exitButton[0].setAttribute("id", "saveAndSuspend-exit");
      exitButton[0].setAttribute("type", "button");
    }, 500);
  }

  dialogInit(
    reference: ComponentRef<IModalDialog>,
    options: Partial<IModalDialogOptions<string>>
  ) {
    this.actionButtons = [
      {
        text: "",
        buttonClass: "alg-btn-close",
        onAction: () => {
          this.utils.abilityOverflow();
          return true;
        },
      },
      {
        text: "Torna alla compilazione",
        buttonClass: "button-cancel-product",
        onAction: () => {
          this.utils.abilityOverflow();
          return true;
        },
      },
    ];
    options.actionButtons = this.actionButtons;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dialogs/stop-onboarding-modal/stop-onboarding-modal.component.ts